
import { useNavigate } from 'react-router-dom';
import { useToast } from '../hooks/useToast';
import API_URL from '../config/API_URL';
import React, { useState, useEffect } from 'react';
import { X, Play, Clock, Star, Book, ArrowRight, Crown, Lock } from 'lucide-react';

 // Replace with your actual API URL

export const RequestStoryModal = ({ isOpen, onClose, readerId, readerName, kids, user }) => {
  const [unrecordedBooks, setUnrecordedBooks] = useState([]);
  const [unrecordedPremiumBooks, setUnrecordedPremiumBooks] = useState([]);
  const [selectedKid, setSelectedKid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [requesting, setRequesting] = useState(false);
  const [activeTab, setActiveTab] = useState('regular'); // 'regular' or 'premium'

  useEffect(() => {
    if (isOpen && readerId) {
      fetchUnrecordedBooks();
      fetchUnrecordedPremiumBooks();
      // Auto-select if only one kid
      if (kids && kids.length === 1) {
        setSelectedKid(kids[0].id);
      }
    }
  }, [isOpen, readerId, kids]);

  const fetchUnrecordedBooks = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/reader/${readerId}/unrecorded-books`, {
        credentials: 'include'
      });
      
      if (!response.ok) throw new Error('Failed to fetch books');
      
      const data = await response.json();
      setUnrecordedBooks(data);
    } catch (error) {
      console.error('Error fetching unrecorded books:', error);
    } finally {
      setLoading(false);
    }
  };
  console.log(user)

  const fetchUnrecordedPremiumBooks = async () => {
    try {
      const response = await fetch(`${API_URL}/api/reader/${user.id}/premium-unrecorded-books`, {
        credentials: 'include'
      });
      
      if (!response.ok) throw new Error('Failed to fetch premium books');
      
      const data = await response.json();
      console.log('DEAN ', data)
      setUnrecordedPremiumBooks(data);
    } catch (error) {
      console.error('Error fetching premium unrecorded books:', error);
      setUnrecordedPremiumBooks([]);
    }
  };

  const handleRequestStory = async (book, isPremium = false) => {
    if (!selectedKid) {
      alert('Please select a child first');
      return;
    }

    try {
      setRequesting(true);
      const response = await fetch(`${API_URL}/api/queue/request-story`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          book_id: book.id,
          kid_id: selectedKid,
          reader_id: readerId,
          type: 'requested',
          is_premium: isPremium
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to request story');
      }

      alert(`Story request for "${book.title}" has been sent to ${readerName}!`);
      onClose();
      
    } catch (error) {
      console.error('Error requesting story:', error);
      alert(`Failed to request story: ${error.message}`);
    } finally {
      setRequesting(false);
    }
  };

  if (!isOpen) return null;

  const currentBooks = activeTab === 'regular' ? unrecordedBooks : unrecordedPremiumBooks;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '1rem',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        {/* Header */}
        <div style={{
          padding: '1.5rem',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937' }}>
              Request a Story from {readerName}
            </h2>
            <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '0.25rem' }}>
              Choose a book that {readerName} hasn't recorded yet
            </p>
            
            {/* Kid Selector */}
            {kids && kids.length > 0 && (
              <div style={{ 
                marginTop: '1rem',
                padding: '1rem',
                backgroundColor: '#fef3c7',
                border: '2px solid #fbbf24',
                borderRadius: '0.75rem'
              }}>
                <label style={{ 
                  fontSize: '1rem', 
                  fontWeight: '600', 
                  color: '#92400e',
                  display: 'block',
                  marginBottom: '0.75rem'
                }}>
                  ⚠️ First, select which child this story is for:
                </label>
                <select
                  value={selectedKid || ''}
                  onChange={(e) => setSelectedKid(Number(e.target.value))}
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '2px solid #fbbf24',
                    borderRadius: '0.5rem',
                    fontSize: '1rem',
                    fontWeight: '500',
                    color: '#1f2937',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                  }}
                >
                  <option value="">-- Select a child --</option>
                  {kids.map(kid => (
                    <option key={kid.id} value={kid.id}>
                      {kid.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem',
              borderRadius: '0.5rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s',
              marginLeft: '1rem'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <X size={24} color="#6b7280" />
          </button>
        </div>

        {/* Tab Navigation */}
        <div style={{
          display: 'flex',
          borderBottom: '2px solid #e5e7eb',
          backgroundColor: '#f9fafb'
        }}>
          <button
            onClick={() => setActiveTab('regular')}
            style={{
              flex: 1,
              padding: '1rem',
              background: activeTab === 'regular' ? 'white' : 'transparent',
              border: 'none',
              borderBottom: activeTab === 'regular' ? '3px solid #db2777' : '3px solid transparent',
              cursor: 'pointer',
              fontWeight: activeTab === 'regular' ? '600' : '400',
              color: activeTab === 'regular' ? '#db2777' : '#6b7280',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              transition: 'all 0.2s'
            }}
          >
            <Book size={20} />
            Regular Books ({unrecordedBooks.length})
          </button>
          <button
            onClick={() => setActiveTab('premium')}
            style={{
              flex: 1,
              padding: '1rem',
              background: activeTab === 'premium' ? 'white' : 'transparent',
              border: 'none',
              borderBottom: activeTab === 'premium' ? '3px solid #fbbf24' : '3px solid transparent',
              cursor: 'pointer',
              fontWeight: activeTab === 'premium' ? '600' : '400',
              color: activeTab === 'premium' ? '#f59e0b' : '#6b7280',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              transition: 'all 0.2s'
            }}
          >
            <Crown size={20} />
            Premium Books ({unrecordedPremiumBooks.length})
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '1.5rem', overflowY: 'auto', flex: 1 }}>
          {loading ? (
            <p style={{ textAlign: 'center', color: '#6b7280' }}>Loading available books...</p>
          ) : currentBooks.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <Star size={48} color="#d1d5db" style={{ margin: '0 auto 1rem' }} />
              <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>
                {activeTab === 'premium' 
                  ? `${readerName} has recorded all their unlocked premium books!`
                  : `${readerName} has recorded all available regular books!`
                }
              </p>
            </div>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '1.5rem'
            }}>
              {currentBooks.map(book => (
                <div
                  key={book.id}
                  style={{
                    border: activeTab === 'premium' ? '2px solid #fbbf24' : '1px solid #e5e7eb',
                    borderRadius: '0.75rem',
                    padding: '1rem',
                    background: activeTab === 'premium' 
                      ? 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)' 
                      : 'white',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem',
                    position: 'relative'
                  }}
                >
                  {/* Premium Badge */}
                  {activeTab === 'premium' && (
                    <div style={{
                      position: 'absolute',
                      top: '0.5rem',
                      right: '0.5rem',
                      background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                      color: 'white',
                      padding: '0.25rem 0.5rem',
                      borderRadius: '0.25rem',
                      fontSize: '0.625rem',
                      fontWeight: '700',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.25rem'
                    }}>
                      <Crown size={10} />
                      PREMIUM
                    </div>
                  )}

                  {/* Book Preview */}
                  {book.pdf_url ? (
                    <div style={{
                      width: '100%',
                      height: '250px',
                      border: activeTab === 'premium' ? '1px solid #fbbf24' : '1px solid #e5e7eb',
                      borderRadius: '0.5rem',
                      overflow: 'hidden',
                      backgroundColor: activeTab === 'premium' ? '#fffbeb' : '#f9fafb'
                    }}>
                      <iframe
                        src={`${book.pdf_url}#page=1&view=FitH`}
                        style={{
                          width: '100%',
                          height: '100%',
                          border: 'none',
                          pointerEvents: 'none'
                        }}
                        title={book.title}
                      />
                    </div>
                  ) : (
                    <div style={{
                      width: '100%',
                      height: '250px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '0.5rem',
                      backgroundColor: '#f9fafb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '4rem'
                    }}>
                      {activeTab === 'premium' ? '👑' : '📖'}
                    </div>
                  )}

                  {/* Book Info */}
                  <div>
                    <h4 style={{
                      fontSize: '1rem',
                      fontWeight: '600',
                      color: '#1f2937',
                      marginBottom: '0.25rem'
                    }}>
                      {book.title}
                    </h4>
                    <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      by {book.author}
                    </p>
                    {book.description && (
                      <p style={{
                        fontSize: '0.75rem',
                        color: '#9ca3af',
                        marginTop: '0.5rem',
                        lineHeight: '1.4'
                      }}>
                        {book.description}
                      </p>
                    )}
                  </div>

                  {/* Request Button */}
                  <button
                    onClick={() => handleRequestStory(book, activeTab === 'premium')}
                    disabled={!selectedKid || requesting}
                    style={{
                      background: !selectedKid || requesting 
                        ? '#9ca3af' 
                        : activeTab === 'premium'
                        ? 'linear-gradient(135deg, #fbbf24, #f59e0b)'
                        : '#059669',
                      color: 'white',
                      border: 'none',
                      padding: '0.625rem',
                      borderRadius: '0.5rem',
                      cursor: !selectedKid || requesting ? 'not-allowed' : 'pointer',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      transition: 'background-color 0.2s',
                      width: '100%',
                      opacity: !selectedKid || requesting ? 0.6 : 1
                    }}
                    onMouseEnter={(e) => {
                      if (selectedKid && !requesting) {
                        e.currentTarget.style.transform = 'scale(1.02)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedKid && !requesting) {
                        e.currentTarget.style.transform = 'scale(1)';
                      }
                    }}
                  >
                    {requesting ? 'Requesting...' : 'Request Story'} <ArrowRight size={16} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};